import { Logger } from "@nolimitcity/slot-launcher/bin/utils/Logger";
import { BasicSymbolType } from "../../../core/reel/symbol/config/IReelSymbolStruct";
import { ArrayHelper } from "../../../core/utils/ArrayHelper";
import { SanEngineManager } from "../../engine/SanEngineManager";
import { DataUtil } from "../base/DataUtil";
import { BaseServerData, SanJumpData } from "../base/IData";

export abstract class CoreData extends DataUtil {

    protected data: BaseServerData;

    constructor(){ super() }

    public apply(data: BaseServerData):void { 
        this.data = data;
    }

    public isWinBelowStake(): boolean { Logger.warn("isWinBelowStake : Is not Replaced!"); return false;};
    public isIndiviWinBelowStake(): boolean { Logger.warn("isWinBelowStake : Is not Replaced!"); return false;};

    protected fetchSymbolPos(symType: string, windowReel: string[][], singleSymPerReel?: boolean): number[][] | number[] {
        const arr: number[][] | [] = [];

        let pos: number = -1;
        for (let reel: number = 0; reel < windowReel.length; reel++) {
            if (!singleSymPerReel) arr[reel] = [];
            else pos = -1;
            for (let row: number = 0; row < windowReel[reel].length; row++) {
                if (windowReel[reel][row] == symType) {
                    if (singleSymPerReel) {
                        pos = row;
                        break;
                    }
                    else arr[reel].push(row)
                }
            }
            if (singleSymPerReel) (arr as number[]).push(pos)
        }
        return arr;
    }

    protected jumpDecryption(jumpData:string):SanJumpData[]{
        if(!jumpData) return [];
        const amountOfJumpers:string[] = jumpData.split(";").filter((s) => { return s });
        const arr:SanJumpData[] = [];
        
        for(let j:number= 0; j < amountOfJumpers.length; j++){
            const splittedData:string[] = amountOfJumpers[j].split(":");
            arr.push( defining(
                pos(splittedData[0]), // Reel
                pos(splittedData[1]), // Row
                [ parseFloat(splittedData[2]),parseFloat(splittedData[3]) // Multi
            ]));
        }

        function defining (from:number[],to:number[],multiplier:number[]):SanJumpData{
            return { 
                from:{ reel:from[0], row:from[1], multiplier:multiplier[0]} ,
                to: { reel:to[0], row:to[1], multiplier:multiplier[1]} };
        }
        
        function pos (val:string):number[]{
             return val.split(",").map((s:string) => { if(parseFloat(s) < 0 ) return 0; return parseFloat(s)});
         }

        return arr;
    }

    protected createNormalNearWinMap():number[][]{

        const rHeight:number = 3;

        // For some reason, this is the only solution i got to bypass the reference.
        const reelCopied:string[][] = [];
        for(let i = 0; i < this.data.reels.length;i++){
            reelCopied.push(Array.from(this.data.reels[i]));
        }
        
        let startM:number[] = ArrayHelper.initArrayWithValues(rHeight,(index:number) => {return index;});
        let map:number[][] = [startM];

         // WildConnection
        for(let w:number = 0; w < reelCopied.length;w++){
            if(reelCopied[w].indexOf(BasicSymbolType.WILD) >= 1 && reelCopied[w].indexOf(BasicSymbolType.WILD) < 4 && map.length != 5)
                map.push(ArrayHelper.initArrayWithValues(rHeight,(index:number) => {return index;}));
            else break;
        }

        const checkSymStartOffset:number = map.length;
        // Create normal map for symbols that crosses itself and special symbols.
        for(let offs:number = 0; offs < checkSymStartOffset;offs++){
            for(let symPos:number = 0; symPos < rHeight; symPos++){
                let startSym:string = reelCopied[offs][symPos+1];

                if(startSym === BasicSymbolType.WILD) continue;
                for(let reel:number = 1; reel < SanEngineManager.AllReels.length;reel++){
                    let arrFindings:number[] = findSymbolPos(reel, [startSym, BasicSymbolType.WILD],[BasicSymbolType.SCATTER,BasicSymbolType.BONUS]);
                    if(arrFindings.length == 0) break;
                    if(map.length == reel)
                        map.push([]);

                    for(let j:number = 0; j < arrFindings.length;j++) 
                        if(map[reel].indexOf(arrFindings[j]) == -1 ) map[reel].push(arrFindings[j]);
                }
                map = map.filter(arr => { return arr.length > 0} )
            }
        }

        function findSymbolPos(reel:number,symbol:string[],ignoreSymbol:string[]):number[]{
            let temp:number[] = [];
            for(let symPos:number = 0; symPos < rHeight; symPos++){
                let sym = reelCopied[reel][symPos+1];
                if(ignoreSymbol.indexOf(sym) >= 0) continue;
                if(symbol.indexOf(sym) >= 0 && temp.indexOf(symPos) == -1) temp.push(symPos);
            }
            return temp;
        }
        return map;
    }

    protected findMultSymbol(symbol:string[],windowReel: string[][]):number[][]{
        let arr:number[][] = [];

        for(let reel = 0; reel < windowReel.length; reel++){
            arr.push([])
            for(let row:number = 0; row < 3; row++){
                if(symbol.indexOf(windowReel[reel][row+1]) >= 0){
                    arr[reel].push(row);
                } 
            }
        }
        return arr;
    }
}
